import { z } from 'zod';

const uploadFilesSchema = z.array(
  z.object({
    filePath: z.string().min(1, 'File path is required.'),
    fileName: z.string().min(1, 'File name is required.'),
    isUploading: z.boolean().optional(),
  }),
);

export default uploadFilesSchema;
